export const Quantities = {

    QUANTITY_1: {id: 1, text: 'Ballen', value: 'quantity1'},
    QUANTITY_2: {id: 1, text: 'Kubikmeter', value: 'quantity2'},
    QUANTITY_3: {id: 1, text: 'keine Ernte', value: 'quantity3'},

    list() {
        return [
            this.QUANTITY_1,
            this.QUANTITY_2,
            this.QUANTITY_3
        ]
    },

    itemByValue(value) {
        let quantity = this.list().find(item => item.value === value)
        return typeof(quantity)==="undefined" ? false : quantity
    }
}
